interface ItemInforProps {
    label: string,
    value: any
}

export default function ItemInformation({ label, value }: ItemInforProps) {
    return (
        <div className='flex flex-col gap-1'>
            <div className='text-text-4'>{label}</div>
            <div>{value}</div>
        </div>
    );
};
